import { SET_TABLE_CONFIG, UPDATE_TABLE_CONFIG, CLEAR_TABLE_CONFIG } from '#action/types';
import defaultColumns from '#component/table/configurable-table/default-columns';

const syncConfigs = (defaultConfig, fetchedConfig) =>
  fetchedConfig.map(fetchedItem => {
    const defaultItem = defaultConfig.find(({ id }) => id === fetchedItem.id);

    if (!defaultItem) return fetchedItem;

    const syncedItem = {};

    Object.keys(defaultItem).forEach(key => {
      syncedItem[key] = Object.prototype.hasOwnProperty.call(fetchedItem, key) ?
        fetchedItem[key] : defaultItem[key];
    });

    return syncedItem;
  });

const initialState = {
  columns: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TABLE_CONFIG:
      const { config, key } = action.payload;
      const defaultConfig = defaultColumns[key];
      const syncedConfigs = syncConfigs(defaultConfig, config);

      return {
        ...state,
        columns: syncedConfigs
      };
    case UPDATE_TABLE_CONFIG:
      return { ...state, columns: action.payload };
    case CLEAR_TABLE_CONFIG: {
      return initialState;
    }
    default:
      return state;
  }
};
